var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3410_9305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 25C14.2199 25 12.4799 24.4721 10.9998 23.4832C9.51979 22.4943 8.36624 21.0886 7.68507 19.4441C7.00389 17.7996 6.82567 15.99 7.17295 14.2441C7.52022 12.4983 8.3774 10.8947 9.63608 9.636C10.8948 8.37734 12.4984 7.52018 14.2442 7.17293C15.9901 6.82567 17.7997 7.00391 19.4442 7.68511C21.0887 8.36631 22.4943 9.51987 23.4833 10.9999C24.4722 12.48 25 14.22 25 16.0001C24.9973 18.3862 24.0482 20.6738 22.3609 22.361C20.6737 24.0482 18.3861 24.9973 15.9999 25ZM15.9999 8.16441C14.4502 8.16442 12.9353 8.62398 11.6467 9.48497C10.3582 10.346 9.3539 11.5697 8.76085 13.0015C8.1678 14.4332 8.01263 16.0087 8.31497 17.5287C8.61731 19.0486 9.36358 20.4448 10.4594 21.5406C11.5552 22.6364 12.9514 23.3827 14.4713 23.685C15.9913 23.9874 17.5668 23.8322 18.9985 23.2392C20.4303 22.6461 21.654 21.6418 22.515 20.3533C23.376 19.0647 23.8356 17.5498 23.8356 16.0001C23.8332 13.9226 23.0069 11.931 21.538 10.462C20.069 8.99305 18.0774 8.16676 15.9999 8.16441Z",
    fill: "url(#paint0_linear_3410_9305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.287 19.8659C19.2106 19.866 19.1348 19.851 19.0642 19.8217C18.9936 19.7924 18.9294 19.7495 18.8754 19.6953L15.4219 16.242V11.0197C15.4219 10.8653 15.4832 10.7172 15.5924 10.608C15.7016 10.4988 15.8497 10.4375 16.0041 10.4375C16.1585 10.4375 16.3066 10.4988 16.4158 10.608C16.5249 10.7172 16.5863 10.8653 16.5863 11.0197V15.7597L19.6987 18.8721C19.7801 18.9535 19.8355 19.0572 19.858 19.1701C19.8804 19.2831 19.8689 19.4001 19.8248 19.5065C19.7808 19.6129 19.7062 19.7038 19.6105 19.7678C19.5147 19.8317 19.4022 19.8659 19.287 19.8659Z",
    fill: "url(#paint1_linear_3410_9305)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3410_9305",
    x1: 23.54,
    y1: 7,
    x2: 12.8398,
    y2: 18.2296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3410_9305",
    x1: 19.5084,
    y1: 10.4375,
    x2: 15.0464,
    y2: 12.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CAFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEB9EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3410_9305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.200a36d5.svg";
export { ForwardRef as ReactComponent };